export const salam = () => {
  const h = new Date().getHours();
  return h < 11 ? "pagi" : h < 15 ? "siang" : h < 18 ? "sore" : "malam";
};

// {salam} → pagi/siang/sore/malam sesuai jam saat dikirim
export const renderQuickReply = (text) => (text || "").replace(/\{salam\}/gi, salam());
